import { render } from "./WarnModal.vue?vue&type=template&id=42f200fa"
import script from "./WarnModal.vue?vue&type=script&lang=js"
export * from "./WarnModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__